import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApolloUserService } from '@core/graphql/apolloUser.service';
import { AuthService } from '../auth.service';
import { UserPoco, ResponseDTO, UserClaim } from '@data/DTO/DTO';
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {
  signInForm!: FormGroup;
  submittedSignInForm = false;
  progressState: boolean = false;
  showAlert: boolean = false;
  alertProperties = { type: '', message: '' };
  passwordVisible: boolean = false;
  isError: boolean = false;
  loginErrorMessage: string = '';
  constructor(private formBuilder: FormBuilder, private router: Router, private userService: ApolloUserService, private authService: AuthService) { }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.signInForm = this.formBuilder.group({
      email: [null, [Validators.required, Validators.email]],
      password: [null, Validators.required],
    });
  }

  get f() {
    return this.signInForm.controls;
  }

  onSignIn() {
    this.submittedSignInForm = true;
    if (this.signInForm.invalid) {
      return;
    }

    this.progressState = true;
    localStorage.clear();
    const { email, password } = this.signInForm.value;

    this.userService.authenticate(email, password).subscribe(
      (response: ResponseDTO<UserPoco>) => {
        if (response && response.data) {
          const _user = response.data;
          const _decodedToken = jwtDecode<UserClaim>(_user.token);
          localStorage.setItem("userClaim", JSON.stringify(_decodedToken));
          localStorage.setItem("userSecret", response.data?.token);
          localStorage.setItem("userProfile", JSON.stringify(response));
          this.handleResponse(response);
        } else {
          this.handleLoginError(response.error || 'Failed to Login');
        }
      },
      () => {
        this.handleLoginError('Failed to Login');
      }
    );
  }

  handleResponse(response: ResponseDTO<UserPoco>) {
    this.progressState = false;
    if (response.success) {
      this.displayAlert("success", "Login Successfully");
      const role = this.authService.getUserRole();
      this.router.navigate(['/dashboard']).then(() => {
        location.reload();
      });
    } else {
      this.handleLoginError(response.error || 'Login failed');
    }
  }

  handleLoginError(errorMessage: string): void {
    this.isError = true;
    this.loginErrorMessage = errorMessage;
    this.progressState = false;
    this.displayAlert('danger', errorMessage);
  }

  togglePasswordVisibility(): void {
    this.passwordVisible = !this.passwordVisible;
  }

  displayAlert(type: string, message: string) {
    this.showAlert = true;
    this.alertProperties = { type, message };
    window.setTimeout(() => {
      this.showAlert = false;
    }, 5000);
  }
}